import { getUnixTime } from "date-fns"
import { bloombergData } from "../../../api/bloomberg"

export const createSerie = (data: bloombergData[] | undefined) => {
  if (!data || data.length === 0) return [] // Handle empty data
  // getUnixTime returns unix datetime in second so need to multilpy by 1000 to have it in ms for highchart
  return data?.map(e => [getUnixTime(new Date(e.datetime)) * 1000, e.value])
}
